import React from 'react';
import classNames from "classnames";

export default (props) => {
    const buttonClasses = classNames(
        'tab_button',
        {
            'active' : props.activeTab === props.name,
            'completed' : props.completed,
            'vehicle_button' : props.type === "vehicle",
            'part_button' : props.type === "part"
        }
    );

    return (
        <div className={buttonClasses} onClick={() => props.clickAction(props.name)}>
            <img src={"https://media.partauto.fr/icon/"+props.name+"_search.png"} alt={props.name}/>
            <p>{props.description}</p>
        </div>
    )
}